export default __webpack_public_path__ + "static/media/icone-maintenance.30cfffce.svg";